import logoMark from '../../assets/logo-mark.svg';

export interface NavLink {
  label: string;
  href: string;
  external?: boolean;
}

/** In-page anchors, so only the landing page uses these. */
export const HOME_LINKS: NavLink[] = [
  { label: 'Product', href: '#platform' },
  { label: 'Platform', href: '#capabilities' },
  { label: 'Developers', href: '#developers' },
  { label: 'Team', href: '/team' },
  { label: 'Documentation', href: 'https://docs.briefcaseai.org/', external: true },
];

/** Every other route, where the anchors do not exist. */
export const PAGE_LINKS: NavLink[] = [
  { label: 'Home', href: '/' },
  { label: 'Platform', href: '/#platform' },
  { label: 'Developers', href: '/#developers' },
  { label: 'Team', href: '/team' },
  { label: 'Documentation', href: 'https://docs.briefcaseai.org/', external: true },
];

/**
 * Two bordered tiles floating on the paper shell. Sticky, so the tiles carry
 * their own paper ground and content scrolls beneath them.
 */
export function SiteNav({ links = HOME_LINKS }: { links?: NavLink[] }) {
  return (
    <nav className="sticky top-0 z-[100] px-5 py-4 sm:px-8" aria-label="Primary">
      <div className="mx-auto flex max-w-[1120px] items-center justify-between gap-3">
        <a
          href="/"
          className="flex items-center gap-2.5 rounded-tile border border-rule bg-paper py-2 pl-2 pr-3.5 no-underline"
        >
          <img src={logoMark} alt="" className="h-7 w-7 shrink-0 rounded-[7px] object-cover" />
          <span className="whitespace-nowrap text-[15px] font-semibold tracking-[-0.01em] text-ink">
            Briefcase AI
          </span>
        </a>

        <div className="flex items-center gap-0.5 rounded-tile border border-rule bg-paper p-1.5">
          <div className="hidden lg:flex lg:items-center">
            {links.map((link) => (
              <a
                key={link.label}
                href={link.href}
                target={link.external ? '_blank' : undefined}
                rel={link.external ? 'noopener noreferrer' : undefined}
                className="whitespace-nowrap px-3 py-2 text-[14px] font-medium text-ink-2 no-underline transition-opacity hover:opacity-70"
              >
                {link.label}
              </a>
            ))}
          </div>

          <a
            href="/contact"
            data-analytics="click"
            data-cta="nav-primary"
            className="bc-btn rounded-md px-4 py-2.5 text-[14px]"
          >
            Book a Demo
          </a>
        </div>
      </div>
    </nav>
  );
}
